// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brand-add-container {
  max-width: 900px;
  margin: 40px auto;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.dark .brand-add-container {
  background-color: rgb(15 23 42);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.brand-add-container h1 {
  font-size: 28px;
  margin-bottom: 30px;
  color: #333;
  text-align: center;
}

.dark .brand-add-container h1 {
  color: rgb(241 245 249);
}

.brand-add-container h2 {
  font-size: 22px;
  color: #333;
  margin-top: 30px;
  margin-bottom: 15px;
  font-weight: 600;
}

.dark .brand-add-container h2 {
  color: rgb(241 245 249);
}

.brand-add-container h3 {
  font-size: 16px;
  color: #444;
  margin-bottom: 8px;
  font-weight: 600;
}

.dark .brand-add-container h3 {
  color: rgb(203 213 225);
}

.brand-add-form {
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #444;
  font-size: 14px;
}

.dark .form-group label {
  color: rgb(148 163 184);
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  box-sizing: border-box;
  transition: border-color 0.3s;
}

.dark .form-group input,
.dark .form-group select {
  background-color: rgb(15 23 42);
  border-color: rgb(51 65 85);
  color: rgb(241 245 249);
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #4CAF50;
}

.dark .form-group input:focus,
.dark .form-group select:focus {
  border-color: #4CAF50;
}

.form-group input:disabled,
.form-group select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}

.dark .form-group input:disabled,
.dark .form-group select:disabled {
  background-color: rgb(30 41 59);
}

.country-selector {
  position: relative;
}

.country-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 0.25rem;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-height: 250px;
  overflow-y: auto;
  z-index: 1000;
}

.dark .country-dropdown {
  background: rgb(15 23 42);
  border-color: rgb(51 65 85);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.4);
}

.country-option {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.country-option:hover {
  background-color: #f3f4f6;
}

.dark .country-option:hover {
  background-color: rgb(30 41 59);
}

.country-option.selected {
  background-color: #dbeafe;
  color: #1e40af;
}

.dark .country-option.selected {
  background-color: rgb(30 58 138);
  color: rgb(147 197 253);
}

.country-flag {
  font-size: 0.8rem;
  padding: 0.25rem 0.5rem;
  background-color: #e5e7eb;
  border-radius: 4px;
  font-weight: 600;
}

.dark .country-flag {
  background-color: rgb(51 65 85);
  color: rgb(203 213 225);
}

.country-name {
  font-size: 0.9rem;
}

.dark .country-name {
  color: rgb(203 213 225);
}

.no-results {
  padding: 0.75rem;
  text-align: center;
  color: #6b7280;
  font-size: 0.9rem;
}

.dark .no-results {
  color: rgb(148 163 184);
}

.dropdown-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

.selected-items {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.75rem;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
}

.tag-vertical {
  background-color: #e9d5ff;
  color: #6b21a8;
}

.tag-country {
  background-color: #dbeafe;
  color: #1e40af;
}

.tag-flag {
  font-size: 0.75rem;
  padding: 0.15rem 0.35rem;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 3px;
  font-weight: 600;
}

.tag-remove {
  background: none;
  border: none;
  color: inherit;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0;
  margin-left: 0.25rem;
  line-height: 1;
  transition: opacity 0.2s;
}

.tag-remove:hover {
  opacity: 0.7;
}

.submit-btn {
  width: 100%;
  padding: 14px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 10px;
}

.submit-btn:hover:not(:disabled) {
  background-color: #45a049;
}

.submit-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.csv-upload-group {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 2px solid #e5e7eb;
}

.csv-upload-group input[type="file"] {
  padding: 10px;
  border: 2px dashed #ddd;
  border-radius: 4px;
  background-color: #fafafa;
  cursor: pointer;
  transition: all 0.3s;
}

.csv-upload-group input[type="file"]:hover:not(:disabled) {
  border-color: #4CAF50;
  background-color: #f0f8f0;
}

.csv-upload-group input[type="file"]:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.file-info {
  display: block;
  margin-top: 8px;
  color: #4CAF50;
  font-size: 13px;
  font-weight: 600;
}

.csv-format-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.dark .csv-format-info {
  background-color: rgb(30 41 59);
  border-color: rgb(51 65 85);
}

.csv-format-info p {
  margin: 5px 0;
  font-size: 13px;
  color: #666;
}

.dark .csv-format-info p {
  color: rgb(148 163 184);
}

.csv-format-info code {
  display: block;
  padding: 10px;
  background-color: #2e3440;
  color: #88c0d0;
  border-radius: 4px;
  margin: 8px 0;
  font-size: 13px;
  font-family: 'Courier New', monospace;
}

.error-message {
  padding: 15px;
  background-color: #ffebee;
  border-left: 4px solid #f44336;
  color: #c62828;
  border-radius: 4px;
  margin-top: 20px;
}

.dark .error-message {
  background-color: rgb(127 29 29);
  color: rgb(252 165 165);
}

.error-message strong {
  font-weight: 600;
}

.success-message {
  padding: 15px;
  background-color: #e8f5e9;
  border-left: 4px solid #4CAF50;
  color: #2e7d32;
  border-radius: 4px;
  margin-top: 20px;
}

.dark .success-message {
  background-color: rgb(20 83 45);
  color: rgb(134 239 172);
}

.success-message strong {
  font-weight: 600;
}

/* Progress Display Styles */
.progress-container {
  margin-top: 25px;
  padding: 20px;
  background-color: #f0f8ff;
  border: 2px solid #4CAF50;
  border-radius: 8px;
}

.dark .progress-container {
  background-color: rgb(15 23 42);
  border-color: #4CAF50;
}

.progress-container h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #2e7d32;
  font-size: 18px;
}

.dark .progress-container h3 {
  color: rgb(134 239 172);
}

.current-step {
  padding: 12px 15px;
  background-color: #fff3cd;
  border-left: 4px solid #ffc107;
  border-radius: 4px;
  margin-bottom: 15px;
  font-size: 15px;
  color: #856404;
  animation: pulse 2s infinite;
  display: flex;
  align-items: center;
  gap: 10px;
}

.dark .current-step {
  background-color: rgb(113 63 18);
  color: rgb(253 224 71);
}

.current-step strong {
  font-weight: 600;
}

.current-step .spinner {
  font-size: 18px;
  animation: spin 1s linear infinite;
}

.progress-log {
  max-height: 400px;
  overflow-y: auto;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px;
}

.dark .progress-log {
  background-color: rgb(15 23 42);
  border-color: rgb(51 65 85);
}

.progress-item {
  padding: 8px 10px;
  margin-bottom: 5px;
  font-size: 13px;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.dark .progress-item {
  color: rgb(203 213 225);
  border-bottom-color: rgb(51 65 85);
}

.progress-item:last-child {
  border-bottom: none;
}

.progress-icon {
  color: #4CAF50;
  font-weight: bold;
  flex-shrink: 0;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* URL Verification Styles */
.url-input-container {
  display: flex;
  gap: 10px;
}

.url-input-container input {
  flex: 1 1;
}

.url-input-container input.verified {
  border-color: #4CAF50;
  background-color: #f0f8f0;
}

.verify-btn {
  padding: 12px 20px;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

.verify-btn:hover:not(:disabled) {
  background-color: #1976D2;
}

.verify-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.verify-btn.verified {
  background-color: #4CAF50;
}

.verify-btn.verified:hover:not(:disabled) {
  background-color: #45a049;
}

.verification-message {
  margin-top: 8px;
  padding: 10px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
}

.verification-message.success {
  background-color: #e8f5e9;
  border-left: 3px solid #4CAF50;
  color: #2e7d32;
}

.verification-message.error {
  background-color: #ffebee;
  border-left: 3px solid #f44336;
  color: #c62828;
}

.verification-hint {
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #fff3e0;
  border-left: 3px solid #ff9800;
  border-radius: 4px;
  font-size: 12px;
  color: #e65100;
}

@media (max-width: 768px) {
  .brand-add-container {
    margin: 20px;
    padding: 20px;
  }

  .brand-add-container h1 {
    font-size: 24px;
  }

  .brand-add-container h2 {
    font-size: 20px;
  }

  .brand-add-container h3 {
    font-size: 15px;
  }

  .url-input-container {
    flex-direction: column;
  }

  .verify-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/brandAdd/BrandAdd.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;EAEE,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".brand-add-container {\n  max-width: 900px;\n  margin: 40px auto;\n  padding: 30px;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.dark .brand-add-container {\n  background-color: rgb(15 23 42);\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\n.brand-add-container h1 {\n  font-size: 28px;\n  margin-bottom: 30px;\n  color: #333;\n  text-align: center;\n}\n\n.dark .brand-add-container h1 {\n  color: rgb(241 245 249);\n}\n\n.brand-add-container h2 {\n  font-size: 22px;\n  color: #333;\n  margin-top: 30px;\n  margin-bottom: 15px;\n  font-weight: 600;\n}\n\n.dark .brand-add-container h2 {\n  color: rgb(241 245 249);\n}\n\n.brand-add-container h3 {\n  font-size: 16px;\n  color: #444;\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.dark .brand-add-container h3 {\n  color: rgb(203 213 225);\n}\n\n.brand-add-form {\n  margin-bottom: 30px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #444;\n  font-size: 14px;\n}\n\n.dark .form-group label {\n  color: rgb(148 163 184);\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.3s;\n}\n\n.dark .form-group input,\n.dark .form-group select {\n  background-color: rgb(15 23 42);\n  border-color: rgb(51 65 85);\n  color: rgb(241 245 249);\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #4CAF50;\n}\n\n.dark .form-group input:focus,\n.dark .form-group select:focus {\n  border-color: #4CAF50;\n}\n\n.form-group input:disabled,\n.form-group select:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.dark .form-group input:disabled,\n.dark .form-group select:disabled {\n  background-color: rgb(30 41 59);\n}\n\n.country-selector {\n  position: relative;\n}\n\n.country-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin-top: 0.25rem;\n  background: white;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  max-height: 250px;\n  overflow-y: auto;\n  z-index: 1000;\n}\n\n.dark .country-dropdown {\n  background: rgb(15 23 42);\n  border-color: rgb(51 65 85);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.4);\n}\n\n.country-option {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.country-option:hover {\n  background-color: #f3f4f6;\n}\n\n.dark .country-option:hover {\n  background-color: rgb(30 41 59);\n}\n\n.country-option.selected {\n  background-color: #dbeafe;\n  color: #1e40af;\n}\n\n.dark .country-option.selected {\n  background-color: rgb(30 58 138);\n  color: rgb(147 197 253);\n}\n\n.country-flag {\n  font-size: 0.8rem;\n  padding: 0.25rem 0.5rem;\n  background-color: #e5e7eb;\n  border-radius: 4px;\n  font-weight: 600;\n}\n\n.dark .country-flag {\n  background-color: rgb(51 65 85);\n  color: rgb(203 213 225);\n}\n\n.country-name {\n  font-size: 0.9rem;\n}\n\n.dark .country-name {\n  color: rgb(203 213 225);\n}\n\n.no-results {\n  padding: 0.75rem;\n  text-align: center;\n  color: #6b7280;\n  font-size: 0.9rem;\n}\n\n.dark .no-results {\n  color: rgb(148 163 184);\n}\n\n.dropdown-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n}\n\n.selected-items {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.tag-vertical {\n  background-color: #e9d5ff;\n  color: #6b21a8;\n}\n\n.tag-country {\n  background-color: #dbeafe;\n  color: #1e40af;\n}\n\n.tag-flag {\n  font-size: 0.75rem;\n  padding: 0.15rem 0.35rem;\n  background-color: rgba(255, 255, 255, 0.5);\n  border-radius: 3px;\n  font-weight: 600;\n}\n\n.tag-remove {\n  background: none;\n  border: none;\n  color: inherit;\n  font-size: 1.2rem;\n  cursor: pointer;\n  padding: 0;\n  margin-left: 0.25rem;\n  line-height: 1;\n  transition: opacity 0.2s;\n}\n\n.tag-remove:hover {\n  opacity: 0.7;\n}\n\n.submit-btn {\n  width: 100%;\n  padding: 14px;\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  margin-top: 10px;\n}\n\n.submit-btn:hover:not(:disabled) {\n  background-color: #45a049;\n}\n\n.submit-btn:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.csv-upload-group {\n  margin-top: 30px;\n  padding-top: 30px;\n  border-top: 2px solid #e5e7eb;\n}\n\n.csv-upload-group input[type=\"file\"] {\n  padding: 10px;\n  border: 2px dashed #ddd;\n  border-radius: 4px;\n  background-color: #fafafa;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.csv-upload-group input[type=\"file\"]:hover:not(:disabled) {\n  border-color: #4CAF50;\n  background-color: #f0f8f0;\n}\n\n.csv-upload-group input[type=\"file\"]:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.file-info {\n  display: block;\n  margin-top: 8px;\n  color: #4CAF50;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.csv-format-info {\n  margin-bottom: 20px;\n  padding: 15px;\n  background-color: #f9f9f9;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n}\n\n.dark .csv-format-info {\n  background-color: rgb(30 41 59);\n  border-color: rgb(51 65 85);\n}\n\n.csv-format-info p {\n  margin: 5px 0;\n  font-size: 13px;\n  color: #666;\n}\n\n.dark .csv-format-info p {\n  color: rgb(148 163 184);\n}\n\n.csv-format-info code {\n  display: block;\n  padding: 10px;\n  background-color: #2e3440;\n  color: #88c0d0;\n  border-radius: 4px;\n  margin: 8px 0;\n  font-size: 13px;\n  font-family: 'Courier New', monospace;\n}\n\n.error-message {\n  padding: 15px;\n  background-color: #ffebee;\n  border-left: 4px solid #f44336;\n  color: #c62828;\n  border-radius: 4px;\n  margin-top: 20px;\n}\n\n.dark .error-message {\n  background-color: rgb(127 29 29);\n  color: rgb(252 165 165);\n}\n\n.error-message strong {\n  font-weight: 600;\n}\n\n.success-message {\n  padding: 15px;\n  background-color: #e8f5e9;\n  border-left: 4px solid #4CAF50;\n  color: #2e7d32;\n  border-radius: 4px;\n  margin-top: 20px;\n}\n\n.dark .success-message {\n  background-color: rgb(20 83 45);\n  color: rgb(134 239 172);\n}\n\n.success-message strong {\n  font-weight: 600;\n}\n\n/* Progress Display Styles */\n.progress-container {\n  margin-top: 25px;\n  padding: 20px;\n  background-color: #f0f8ff;\n  border: 2px solid #4CAF50;\n  border-radius: 8px;\n}\n\n.dark .progress-container {\n  background-color: rgb(15 23 42);\n  border-color: #4CAF50;\n}\n\n.progress-container h3 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  color: #2e7d32;\n  font-size: 18px;\n}\n\n.dark .progress-container h3 {\n  color: rgb(134 239 172);\n}\n\n.current-step {\n  padding: 12px 15px;\n  background-color: #fff3cd;\n  border-left: 4px solid #ffc107;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  font-size: 15px;\n  color: #856404;\n  animation: pulse 2s infinite;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.dark .current-step {\n  background-color: rgb(113 63 18);\n  color: rgb(253 224 71);\n}\n\n.current-step strong {\n  font-weight: 600;\n}\n\n.current-step .spinner {\n  font-size: 18px;\n  animation: spin 1s linear infinite;\n}\n\n.progress-log {\n  max-height: 400px;\n  overflow-y: auto;\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  padding: 10px;\n}\n\n.dark .progress-log {\n  background-color: rgb(15 23 42);\n  border-color: rgb(51 65 85);\n}\n\n.progress-item {\n  padding: 8px 10px;\n  margin-bottom: 5px;\n  font-size: 13px;\n  color: #333;\n  border-bottom: 1px solid #f0f0f0;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.dark .progress-item {\n  color: rgb(203 213 225);\n  border-bottom-color: rgb(51 65 85);\n}\n\n.progress-item:last-child {\n  border-bottom: none;\n}\n\n.progress-icon {\n  color: #4CAF50;\n  font-weight: bold;\n  flex-shrink: 0;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* URL Verification Styles */\n.url-input-container {\n  display: flex;\n  gap: 10px;\n}\n\n.url-input-container input {\n  flex: 1;\n}\n\n.url-input-container input.verified {\n  border-color: #4CAF50;\n  background-color: #f0f8f0;\n}\n\n.verify-btn {\n  padding: 12px 20px;\n  background-color: #2196F3;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n  white-space: nowrap;\n}\n\n.verify-btn:hover:not(:disabled) {\n  background-color: #1976D2;\n}\n\n.verify-btn:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.verify-btn.verified {\n  background-color: #4CAF50;\n}\n\n.verify-btn.verified:hover:not(:disabled) {\n  background-color: #45a049;\n}\n\n.verification-message {\n  margin-top: 8px;\n  padding: 10px 12px;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.verification-message.success {\n  background-color: #e8f5e9;\n  border-left: 3px solid #4CAF50;\n  color: #2e7d32;\n}\n\n.verification-message.error {\n  background-color: #ffebee;\n  border-left: 3px solid #f44336;\n  color: #c62828;\n}\n\n.verification-hint {\n  margin-top: 8px;\n  padding: 8px 12px;\n  background-color: #fff3e0;\n  border-left: 3px solid #ff9800;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #e65100;\n}\n\n@media (max-width: 768px) {\n  .brand-add-container {\n    margin: 20px;\n    padding: 20px;\n  }\n\n  .brand-add-container h1 {\n    font-size: 24px;\n  }\n\n  .brand-add-container h2 {\n    font-size: 20px;\n  }\n\n  .brand-add-container h3 {\n    font-size: 15px;\n  }\n\n  .url-input-container {\n    flex-direction: column;\n  }\n\n  .verify-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
